import { render, staticRenderFns } from "./UiLogo.vue?vue&type=template&id=445584cc&"
var script = {}
import style0 from "./UiLogo.vue?vue&type=style&index=0&id=445584cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports